import { FormDataGroup } from 'src/types';

export const leadsPresupuestoPartialData: Partial<FormDataGroup> = {
  headers: { DESC_FORMOBJECTIVE: 'Presupuesto' },
  fields: {
    formFields: {},
    formularioFlag: 'presupuesto',
    formName: 'lead-presupuesto',
    formType: 'quote',
    pageCategory: 'Presupuesto',
  },

};

export const leadsPresupuestoDealerPartialData: Partial<FormDataGroup> = {
  headers: { DESC_FORMOBJECTIVE: 'Presupuesto' },
  fields: {
    formFields: {},
    formularioFlag: 'presupuesto',
    formName: 'lead-presupuesto-dealer',
    formType: 'quote',
    pageCategory: 'Presupuesto',
  },
};
